// Copyright (c) 2022 by Move Closer

import { ComputedRef, Ref } from '@vue/composition-api'
import { VueConstructor } from 'vue'

import { CanHaveTheme } from '../../composables'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface AlertProps extends CanHaveTheme {
  /**
   * Defines whether alert should have close icon (X)
   */
  closable: boolean

  /**
   * Alert inner content
   */
  content?: string
}

/**
 * define possible alert themes
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum AlertTheme {
  Danger = 'danger',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface UseAlertContentProvides {
  /**
   * Reactive value from prop 'content'
   * @see alertProps
   * Showing alert only when currentContent exists
   */
  currentContent: Ref<string | undefined>

  /**
   * Toggleable component that shows Vue component with proper icon regarding
   * the types of alert that use pre-defined variants:
   * @see variantsIconsRegistry
   */
  icon: ComputedRef<VueConstructor>

  /**
   * Determines whether there is a content
   */
  hasContent: ComputedRef<boolean>

  /**
   * handle close behavior of alert
   */
  onClose(): void
}
